@if (isSingle()) {
  @let lesson = lessons()[0];
  <div class="countdown-card">
    <div class="countdown-card-header">
      <span class="countdown-badge">Live Lesson</span>
      <span class="header-icon" aria-hidden="true">💻</span>
    </div>

    <p class="countdown-title">{{ lesson.title }}</p>
    <p class="countdown-subtitle">
      <span class="subtitle-icon" aria-hidden="true">📅</span>
      {{ formattedDate(lesson) }} &middot; {{ formattedTime(lesson) }} (UK)
    </p>

    <app-live-lesson-countdown-timer [targetDate]="lesson.starts_at" />

    <a [routerLink]="['/live-lesson', lesson.id]" class="countdown-cta">Take me to the Live Lesson!</a>
  </div>
} @else {
  <div class="countdown-card">
    <div class="countdown-card-header">
      <span class="countdown-badge">Live Lessons</span>
      <span class="header-icon" aria-hidden="true">💻</span>
    </div>

    <p class="countdown-title">{{ heading() }}</p>
    @if (allToday()) {
      <p class="countdown-subtitle">
        <span class="subtitle-icon" aria-hidden="true">📅</span>
        {{ formattedDate(displayLessons()[0]) }}
      </p>
    }

    <ul class="countdown-lesson-list">
      @for (lesson of displayLessons(); track lesson.id; let i = $index) {
        @if (i > 0) {
          <li class="countdown-lesson-divider" aria-hidden="true"></li>
        }
        <li class="countdown-lesson-row">
          <div class="countdown-lesson-header">
            <span class="countdown-lesson-number">{{ i + 1 }}</span>
            <div class="countdown-lesson-text">
              <span class="countdown-lesson-title">{{ lesson.title }}</span>
              <span class="countdown-lesson-time">
                <img src="assets/images/live-lesson-countdown-clock.svg" alt="" class="time-icon" />
                @if (allToday()) {
                  {{ formattedTime(lesson) }} (UK)
                } @else {
                  {{ formattedDate(lesson) }} &middot; {{ formattedTime(lesson) }} (UK)
                }
              </span>
            </div>
          </div>
          <app-live-lesson-countdown-timer [targetDate]="lesson.starts_at" [compact]="true" />
        </li>
      }
    </ul>

    <button type="button" class="countdown-cta" (click)="openSchedule.emit()">
      <img src="assets/images/live-lesson-countdown-calendar-action.svg" alt="" class="cta-icon" />
      {{ scheduleButtonLabel() }}
    </button>
  </div>
}
